import { FC } from "react";
import Table from "../../../assets/components/Table/Table";
import TableHeader from "../../../assets/components/Table/TableHeader";
import { ColumnDef } from "@tanstack/react-table";
import moment from "moment";
import "./IoloLicenseKeyHistory.scss";
import { FetchLicenseHistory, LicenseHistoryHistoryRow } from "./historyModel";

enum RequestType {
    Request = 0,
    AutomaticJob = 1,
}

enum ActionType {
    Subscribe = 0,
    Cancellation = 1,
    Rebill = 2,
    Refund = 3,
    Activate = 4,
    Deactivate = 5,
    Expire = 6,
    Migrate = 7,
    GracePeriod = 8,
    Reset = 9,
    Delete = 10,
    SubscriptionUpdate = 11,
}

const getRequestTypeKey = (value: number): keyof typeof RequestType => {
    return RequestType[value] as keyof typeof RequestType;
};

const getActionTypeKey = (value: number): keyof typeof ActionType => {
    return ActionType[value] as keyof typeof ActionType;
};

interface IoloLicenseKeyHistoryProps {
    licenseHistory: FetchLicenseHistory[];
}

const IoloLicenseKeyHistory: FC<IoloLicenseKeyHistoryProps> = ({ licenseHistory }) => {
    if (!licenseHistory?.length) return null;

    const columns: ColumnDef<LicenseHistoryHistoryRow>[] = [
        {
            header: "Date",
            accessorFn: ({ createDate }) =>
                moment.unix(Number(createDate)).format("LLL"),
        },
        {
            header: "Request",
            accessorFn: ({ request }) => getRequestTypeKey(request),
        },
        {
            header: "Action",
            accessorFn: ({ action }) => getActionTypeKey(action),
        },
        {
            header: "Message",
            cell: ({ row }) => (
                <div className="license_key_history__table_description">
                    {row.original.description}
                </div>
            ),
        },
    ];

    return (
        <div className="license_key_history">
            <TableHeader title="Notification Logs" borderRadius="small" />

            <Table<LicenseHistoryHistoryRow>
                borderRadius="small"
                className="license_key_history__table"
                data={licenseHistory}
                columns={columns}
                getRowCanExpand={() => false}

                //! This is a mock data for testing purposes
                // data={[
                //     {
                //         createDate: "2025-02-25T18:10:41.95",
                //         request: 1,
                //         action: 1,
                //         description:
                //             "OK: Will expire on 2024-02.15 00:00:01OK: Will expire on 2024-02.15 00:00:01OK: Will expire on 2024-02.15 00:00:01OK: Will expire on 2024-02.15 00:00:01OK: Will expire on 2024-02.15 00:00:01",
                //     },
                // ]}
            />
        </div>
    );
};

export default IoloLicenseKeyHistory;
